import React from "react";
import Modal from "../../../../elements/Modal";
import ScholarshipMessage from "../ScholarshipMessage";

const ScholarshipMessageModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl2" title={"Send Message"}>
      <ScholarshipMessage getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ScholarshipMessageModal;
